import aptCircle from 'assets/logos/apt-circle.svg'
import aptSquare from 'assets/logos/apt-square.svg'
import usdcCircle from 'assets/logos/usdc-circle.svg'
import thAPTLogo from 'assets/logos/thAPT.svg'
import sthAPTLogo from 'assets/logos/sthAPT.png'
import amAPTLogo from 'assets/logos/amAPT.png'
import stAPTLogo from 'assets/logos/stAPT.png'

export type ChainId = string
export interface ChainMeta {
  chainID: string
  logoURL: string
  name: string
  description: string
}

export interface TokenMeta {
  chainID: ChainId
  logo: string
  ticker: string
  name: string
  description: string
  projectURL: string
  displayName: string
}

export interface ChainMetaMap {
  [key: ChainId]: ChainMeta
}

export interface TokenMetaMap {
  [key: string]: TokenMeta
}

export const DEFAULT_CHAIN: ChainMeta = {
  chainID: '',
  logoURL: '',
  name: '',
  description: ''
}

export const DEFAULT_TOKEN: TokenMeta = {
  chainID: '',
  logo: '',
  ticker: '',
  name: '',
  description: '',
  projectURL: '',
  displayName: ''
}

//chains
export const CHAIN_APTOS = 'Aptos'
//logos
export const aptosLogo = aptCircle
export const aptosChainLogo = aptSquare
export const usdcLogo = usdcCircle
//tokens
const APTOS = 'aptos'
const APT_USDC = 'usdc'
const THAPT = 'thapt'
const STH_APT = 'sthapt'
const AM_APT = 'amapt'
const STAKED_APT = 'stapt'

export interface MintMap {
  [key: string]: number
}

//map chain ids to chain meta
export const chains: ChainMetaMap = {
  [CHAIN_APTOS]: {
    name: 'Aptos',
    chainID: CHAIN_APTOS,
    logoURL: aptosChainLogo,
    description: 'Aptos'
  }
}

//token meta objects
export const aptos: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: APTOS,
  ticker: 'APT',
  description: '',
  logo: aptosLogo,
  projectURL: '',
  displayName: 'Aptos'
}

export const apt_usdc: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: APT_USDC,
  ticker: 'zUSDC',
  description: '',
  logo: usdcLogo,
  projectURL: '',
  displayName: 'USD Coin (LayerZero)'
}

export const thAPT: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: THAPT,
  ticker: 'thAPT',
  description: '',
  logo: thAPTLogo,
  projectURL: '',
  displayName: 'Thala APT'
}

export const sthAPT: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: STH_APT,
  ticker: 'sthAPT',
  description: '',
  logo: sthAPTLogo,
  projectURL: '',
  displayName: 'Staked Thala APT'
}

export const amAPT: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: AM_APT,
  ticker: 'amAPT',
  description: '',
  logo: amAPTLogo,
  projectURL: '',
  displayName: 'Amnis APT'
}

export const stakedAPT: TokenMeta = {
  chainID: CHAIN_APTOS,
  name: STAKED_APT,
  ticker: 'stAPT',
  description: '',
  logo: stAPTLogo,
  projectURL: '',
  displayName: 'Staked Amnis APT'
}

export const tokenMetaMap: TokenMetaMap = {
  [APTOS]: aptos,
  [APT_USDC]: apt_usdc,
  [THAPT]: thAPT,
  [STH_APT]: sthAPT,
  [AM_APT]: amAPT,
  [STAKED_APT]: stakedAPT
}
